/*
Creates thumbnail image instead of loading embedded YouTube until clicked to load. 
*/
export class ProductVideos{
    /**
     * @var {any} dataset data from YouTube
     * @var {any} parentNode mixin contains methods and properties that are common to all types of Node objects
     */
    dataset: any;
    parentNode: any;
    
    /**
     * Instantiate the class and create references to the elements on the DOM.
     * 
     * @return {void}
     */
    constructor() {
        const v = document.getElementsByClassName("youtube-player");
        for (const value of v) {
            const div = document.createElement("div");
            div.setAttribute("data-id", value.dataset.id);
            div.innerHTML = this.newThumb(value.dataset.id);
            div.onclick = this.newIframe;
            value.appendChild(div);
        }          
    }

    /**
     * Create a thumbnail to display.
     * 
     * @param {string} id YouTube video id. 
     * 
     * @return {string} thumbnail with play button. 
     */
    private newThumb(id: string) {
        const thumb = '<img src="https://i.ytimg.com/vi/ID/maxresdefault.jpg" alt="Video Thumbnail" loading="lazy">';
        const play = '<div class="tv-video-play-btn"></div>';
        return thumb.replace("ID", id) + play;
    }

    /**
     * Creates the iframe to display video once thumbnail clicked. 
     * 
     * @return {void}
     */
    private newIframe() {
        const iframe = document.createElement("iframe");
        const embed = "https://www.youtube.com/embed/ID?autoplay=1";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        this.parentNode.replaceChild(iframe, this);
    }

} 

export function init() {
    if (document.getElementsByClassName('ty-product-block')) {
        // eslint-disable-next-line no-new
        new ProductVideos();
    }
}
